/* QOWAA FIT — Module barre de progression paliers (window.QowaaTiers).
   Chargé par snippets/qowaa-tiers-bar.liquid → présent partout où la barre l'est
   (page panier + mini-cart PDP/Pack). Source unique de la logique paliers.
   Expose : QowaaTiers.render(container, totalCents), .refresh(cart), .money(cents), .dl(ev, extra)
   GA4 : cart_threshold_reached / cart_threshold_progress (push défensif). */
(function () {
  'use strict';
  if (window.QowaaTiers) return; // garde anti double-chargement

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function dl(ev, extra) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var o = { event: ev }; if (extra) for (var k in extra) o[k] = extra[k];
      window.dataLayer.push(o);
    }
  }

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var nf;
  try { nf = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CURRENCY }); } catch (e) { nf = null; }
  function money(cents) {
    var v = (cents || 0) / 100;
    if (nf) return nf.format(v);
    return v.toFixed(2).replace('.', ',') + ' €';
  }

  var QowaaTiers = {
    _prev: {}, _n: 0,
    money: money,
    dl: dl,

    config: function (container) {
      var el = $('[data-qw-tiers-config]', container);
      if (!el) return null;
      try { return JSON.parse(el.textContent).tiers || []; } catch (e) { return null; }
    },

    render: function (container, totalCents) {
      if (!container) return;
      var tiers = this.config(container);
      if (!tiers || !tiers.length) return;

      var maxEur = tiers[tiers.length - 1].seuil;
      var totalEur = totalCents / 100;
      var pct = Math.min(100, (totalEur / maxEur) * 100);
      var nextTier = null;
      for (var i = 0; i < tiers.length; i++) { if (totalEur < tiers[i].seuil) { nextTier = tiers[i]; break; } }
      var allReached = !nextTier;

      var key = container.getAttribute('data-qw-tiers-id');
      if (!key) { key = 't' + (++this._n); container.setAttribute('data-qw-tiers-id', key); }
      var prev = this._prev[key];
      var fresh = null;
      if (typeof prev === 'number') {
        for (var j = 0; j < tiers.length; j++) {
          if (prev < tiers[j].seuil && totalEur >= tiers[j].seuil) { fresh = tiers[j].seuil; break; }
        }
      }
      this._prev[key] = totalEur;

      var fill = $('[data-qw-tiers-fill]', container);
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('is-full', allReached);
        if (fresh != null) {
          fill.classList.remove('is-shimmering'); void fill.offsetWidth; fill.classList.add('is-shimmering');
          setTimeout(function () { fill.classList.remove('is-shimmering'); }, 950);
        }
      }
      var bar = $('[data-qw-tiers-bar]', container);
      if (bar) bar.setAttribute('aria-valuenow', Math.round(totalEur));

      $all('[data-qw-tiers-node]', container).forEach(function (node) {
        var seuil = parseFloat(node.getAttribute('data-qw-tiers-seuil'));
        node.classList.toggle('is-reached', totalEur >= seuil);
        if (fresh === seuil) {
          node.classList.remove('is-fresh'); void node.offsetWidth; node.classList.add('is-fresh');
          setTimeout(function () { node.classList.remove('is-fresh'); }, 950);
        }
      });

      $all('[data-qw-tiers-label]', container).forEach(function (lbl) {
        var seuil = parseFloat(lbl.getAttribute('data-qw-tiers-seuil'));
        lbl.classList.toggle('is-reached', totalEur >= seuil);
      });

      var cursor = $('[data-qw-tiers-cursor]', container);
      if (cursor) {
        cursor.style.left = pct + '%';
        cursor.classList.toggle('is-at-start', pct < 2);
        cursor.classList.toggle('tiers__cursor--hidden', allReached);
        var amt = $('[data-qw-tiers-cursor-amount]', cursor);
        if (amt) amt.textContent = money(totalCents);
      }

      var check = $('[data-qw-tiers-check]', container);
      var text = $('[data-qw-tiers-text]', container);
      if (text) {
        if (allReached) {
          text.textContent = (tiers.length > 1) ? 'Toutes les récompenses débloquées.' : (tiers[0].reward + ' — débloquée.');
          if (check) {
            check.style.background = ''; check.style.opacity = '';
            var srcCheck = $('[data-qw-tiers-node] .tiers__node-check svg', container);
            if (srcCheck) check.innerHTML = srcCheck.outerHTML;
            if (fresh != null) { check.classList.remove('is-fresh'); void check.offsetWidth; check.classList.add('is-fresh'); }
          }
        } else {
          var manquantCents = Math.max(0, Math.round(nextTier.seuil * 100 - totalCents));
          text.innerHTML = 'Il te manque <strong>' + money(manquantCents) + '</strong> pour ' + nextTier.label + '.';
          if (check) {
            check.style.background = 'var(--qw-chrome-500)'; check.style.opacity = '.92';
            var srcIcon = $('[data-qw-tiers-node][data-qw-tiers-seuil="' + nextTier.seuil + '"] .tiers__node-icon svg', container);
            if (srcIcon) check.innerHTML = srcIcon.outerHTML;
          }
        }
      }

      if (fresh != null) dl('cart_threshold_reached', { threshold_level: fresh });
      dl('cart_threshold_progress', { montant_manquant: nextTier ? Math.max(0, Math.round(nextTier.seuil * 100 - totalCents)) / 100 : 0 });
    },

    refresh: function (cart) {
      var self = this;
      $all('[data-qw-tiers]').forEach(function (c) { self.render(c, cart.total_price); });
    }
  };

  window.QowaaTiers = QowaaTiers;

  // Init passif : rend chaque barre depuis l'état serveur (data-qw-tiers-total)
  function boot() {
    $all('[data-qw-tiers]').forEach(function (c) {
      QowaaTiers.render(c, parseInt(c.getAttribute('data-qw-tiers-total'), 10) || 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
